import { render, staticRenderFns } from "./ConstructionStageContent.vue?vue&type=template&id=a12fd6c4&scoped=true&"
import script from "./ConstructionStageContent.vue?vue&type=script&lang=ts&"
export * from "./ConstructionStageContent.vue?vue&type=script&lang=ts&"
import style0 from "./ConstructionStageContent.vue?vue&type=style&index=0&id=a12fd6c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12fd6c4",
  null
  
)

export default component.exports